module.exports = __webpack_public_path__ + "static/yingzhishi-f2efb7adc175dbfdac0c18c5b4702777.jpg";